module.exports = __webpack_public_path__ + "static/media/bg-desk-2.9b07a6a4.jpg";